export const SEARCH_FIELD_NAME = 'billOwnerId';
export const CHECKBOX_FIELD_NAME = 'associateCurrentOwner';

export const defaultValues = {
    [SEARCH_FIELD_NAME]: '',
    [CHECKBOX_FIELD_NAME]: true,
} as const;
